import { ArrowUpRight } from "lucide-react";
import { Link } from "react-router-dom";
import { LOGO, CALENDLY, ECOM_SITE, DIGIMONK_SITE, PHONES, ADDRESS } from "@/data";
import { trackPhoneClick } from "@/lib/tracking";

export default function Footer() {
  return (
    <footer className="bg-[#0A0A0A] text-[#FDFCF8]" data-testid="footer">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-20">
        <div className="grid lg:grid-cols-[1.4fr_1fr_1fr] gap-14">
          <div>
            <img src={LOGO} alt="DNA Digital" className="h-11 md:h-12 w-auto object-contain" />
            <p className="mt-6 font-display text-3xl md:text-4xl font-extrabold tracking-tighter leading-[0.95] max-w-[18ch]">
              Ads that scale. Automation that sells.
            </p>
            <a
              href={CALENDLY}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="footer-cta-button"
              className="group mt-8 inline-flex items-center gap-3 rounded-full bg-[#F48220] pl-6 pr-2.5 py-2.5 text-black font-body font-semibold hover-lift"
            >
              Book a 1-on-1 Call
              <span className="flex h-8 w-8 items-center justify-center rounded-full bg-black transition-transform duration-500 group-hover:rotate-45">
                <ArrowUpRight className="h-4 w-4 text-white" />
              </span>
            </a>
          </div>

          <div>
            <div className="font-body text-xs font-bold uppercase tracking-[0.25em] text-white/40">Our Networks</div>
            <ul className="mt-5 space-y-3 font-body">
              <li><Link to="/" data-testid="footer-home-link" className="text-white/80 hover:text-[#F48220] transition-colors">Home →</Link></li>
              <li><a href="https://dnadigital.ae/" target="_blank" rel="noopener noreferrer" data-testid="footer-dubai-link" className="text-white/80 hover:text-[#F48220] transition-colors">dnadigital.ae (Dubai) →</a></li>
              <li><a href={ECOM_SITE} target="_blank" rel="noopener noreferrer" data-testid="footer-ecom-link" className="text-white/80 hover:text-[#E70D71] transition-colors">amazonads.co.in →</a></li>
              <li><a href={DIGIMONK_SITE} target="_blank" rel="noopener noreferrer" data-testid="footer-digimonk-link" className="text-white/80 hover:text-[#25D366] transition-colors">digimonk.ai →</a></li>
              <li><Link to="/openai-partner" data-testid="footer-openai-link" className="text-white/80 hover:text-[#34d399] transition-colors">OpenAI Ads Partner →</Link></li>
              <li><a href="#about" className="text-white/80 hover:text-[#3A53A3] transition-colors">About</a></li>
              <li><a href="#services" className="text-white/80 hover:text-[#3A53A3] transition-colors">Services</a></li>
              <li><a href="#results" className="text-white/80 hover:text-[#3A53A3] transition-colors">Results</a></li>
            </ul>
          </div>

          <div>
            <div className="font-body text-xs font-bold uppercase tracking-[0.25em] text-white/40">Talk To Us</div>
            <ul className="mt-5 space-y-2.5 font-body text-sm">
              {PHONES.map((p) => (
                <li key={p.country} className="flex items-center gap-3 text-white/80">
                  <span className="w-10 text-white/40 text-xs">{p.country}</span>
                  <a href={`tel:${p.number.replace(/\s/g, "")}`} onClick={trackPhoneClick} data-testid={`footer-phone-${p.country.toLowerCase()}`} className="hover:text-white transition-colors">{p.number}</a>
                </li>
              ))}
            </ul>
            <p className="mt-6 font-body text-xs text-white/40 leading-relaxed max-w-[30ch]">{ADDRESS}</p>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-white/10 flex flex-col md:flex-row items-center justify-between gap-4">
          <p className="font-body text-xs text-white/40">© {new Date().getFullYear()} DNA Digital. All rights reserved.</p>
          <div className="flex gap-2">
            <span className="h-2 w-2 rounded-full bg-[#F48220]" />
            <span className="h-2 w-2 rounded-full bg-[#E70D71]" />
            <span className="h-2 w-2 rounded-full bg-[#3A53A3]" />
          </div>
        </div>
      </div>
    </footer>
  );
}
